import { apiClient } from './apiClient'

// ============================================
// TIPOS
// ============================================

export interface LibraryDocument {
  id: string
  title: string
  slug: string
  summary: string | null
  document_type: string
  author_name: string | null
  source: string | null
  publication_year: number | null
  cover_image_url: string | null
  page_count: number
  status: 'draft' | 'published'
  featured: boolean
  view_count: number
  created_by: string | null
  created_at: string
  updated_at: string
  published_at: string | null
  deleted_at: string | null
  original_filename: string | null
  taxonomies?: Array<{
    id: string
    name: string
    slug: string
    type: string
  }>
}

export interface ListLibraryParams {
  page?: number
  limit?: number
  search?: string
  taxonomy_id?: string
  document_type?: string
  featured?: string
  status?: string
}

export interface ListLibraryResponse {
  data: LibraryDocument[]
  pagination: {
    page: number
    limit: number
    total: number
    total_pages: number
  }
}

export interface UpdateLibraryDocInput {
  title?: string
  summary?: string
  document_type?: string
  author_name?: string
  source?: string
  publication_year?: number
  status?: 'draft' | 'published'
  featured?: boolean
  taxonomy_ids?: string[]
}

export interface LibraryTaxonomies {
  categories: Array<{ id: string; name: string; slug: string; type: string; description: string }>
  tags: Array<{ id: string; name: string; slug: string; type: string; description: string }>
}

// ============================================
// SERVIÇO
// ============================================

class LibraryService {
  async listDocuments(params?: ListLibraryParams): Promise<ListLibraryResponse> {
    const response = await apiClient.get<ListLibraryResponse>('/content/library/documents', { params })
    return response.data
  }

  async getDocumentById(id: string): Promise<LibraryDocument> {
    const response = await apiClient.get<LibraryDocument>(`/content/library/documents/id/${id}`)
    return response.data
  }

  async createDocument(formData: FormData): Promise<LibraryDocument> {
    const response = await apiClient.post<LibraryDocument>('/content/library/documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000, // 2 min for PDF processing
    })
    return response.data
  }

  async updateDocument(id: string, data: UpdateLibraryDocInput): Promise<LibraryDocument> {
    const response = await apiClient.put<LibraryDocument>(`/content/library/documents/${id}`, data)
    return response.data
  }

  async deleteDocument(id: string): Promise<void> {
    await apiClient.delete(`/content/library/documents/${id}`)
  }

  async getTaxonomies(): Promise<LibraryTaxonomies> {
    const response = await apiClient.get<LibraryTaxonomies>('/content/library/taxonomies')
    return response.data
  }
}

export default new LibraryService()
